"use client";
import { Suspense, useEffect, useRef, useState } from "react";
import PlayFeed from "./PlayFeed";
import ExploreSearchTabs from "@/components/explore-layout-comps/explore-search-tabs";

const PlayFeedLayout = ({ initialPostId, initialFeed }) => {
  const scrollRef = useRef(null);
  const [isScrolled, setIsScrolled] = useState(false);

  const scrollToTop = () => {
    if (scrollRef?.current) {
      scrollRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    if (scrollRef.current) {
      const scrollTop = scrollRef.current.scrollTop;
      if (scrollTop > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    }
  };

  useEffect(() => {
    const scrollableElement = scrollRef.current;
    if (scrollableElement) {
      scrollableElement.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollableElement) {
        scrollableElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  return (
    <div
      ref={scrollRef}
      id="scrollable-box"
      className="w-full max-w-full flex flex-col gap-4 px-[6px] md:px-2 lg:px-4 h-screen overflow-y-auto overflow-x-hidden hide-scrollbar dark:bg-custom_black max-sm:mb-12 border-transparent focus-visible:border-none focus-visible:outline-none"
    >
      <div className="w-full max-w-full lg:max-w-[1400px] lg:mx-auto lg:[--play-card-gap-y:12px]">
        <ExploreSearchTabs />
        <PlayFeed
          scrollToTop={scrollToTop}
          isScrolled={isScrolled}
          initialPostId={initialPostId}
          initialFeed={initialFeed}
        />
      </div>
    </div>
  );
};

export default function ExploreLayoutWrapper(props) {
  return (
    <Suspense fallback={<></>}>
      <PlayFeedLayout {...props} />
    </Suspense>
  );
}
